import { useWidgetContext } from '../context/WidgetContext';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { getForgotPasswordLink, isAthenaOneWebClient } from '../../utils/app-utils';
import { Button } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';
import { launchLwa } from '../../utils/lwa-utils';
const FORGOT_PASSWORD_HASH = '#signin/athena-forgot-password';

export default function ForgotPasswordLink() {
  const {
    settings: { clientId, isAuthnWithLwaClientId },
    athenaOneWebSso,
  } = useWidgetContext();
  if (athenaOneWebSso) return <></>;
  const forgotPasswordUrl = getForgotPasswordLink(clientId);
  const shouldLinkBeDisplayed = isAthenaOneWebClient() || isAuthnWithLwaClientId;

  if (shouldLinkBeDisplayed) {
    return (
      <Button
        text={getLocalizedString('forgotpassword')}
        className="fe_u_font-size--small"
        variant={'tertiary'}
        onClick={async () => {
          await AmplitudeUtils.logCustomEvent('ForgotPasswordButtonClick', {});
          if (isAthenaOneWebClient()) {
            window.location.assign(forgotPasswordUrl!);
          }
          else {
            await launchLwa({ hash: FORGOT_PASSWORD_HASH });
          }
        }}
      />
    );
  }

  return <></>;
}
